import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWatch$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWatch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fffce1be188dd6813a76a2a1ab6a09b5b2c8a5da', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '20247dadfcb6c72777f6ed65f5e81ad8e4f04867', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bd1375c44953d3fa5b3eecd26cd365410af7393a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.45 2h5.113a.5.5 0 0 1 .488.429L14.174 5H16.5a.5.5 0 0 1 .5.5V8h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H17v6.5a.5.5 0 0 1-.5.5h-2.32l-.122 2.571a.5.5 0 0 1-.495.429H8.45a.5.5 0 0 1-.499-.428L7.827 17H5.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h2.33l.125-2.572A.5.5 0 0 1 8.45 2M6.424 15.576h9.152V6.424H6.424z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-watch", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-watch"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-watch":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWatch$1);
            }
            break;
    } });
}

const CosmosIconWatch = CosmosIconWatch$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWatch, defineCustomElement };
